/*
 * This code is the intellectual property of Bulb Inc. and other software publishers;
 * it may not be altered, copied or disclosed without prior written approval.
 * Copyright 2016, Bulb Inc.  For more information, please email contact@hellobulb.com.
 */

angular.module('bulbApp.activityModule', ['angularMoment', 'lodash', 'bulbApp.ajaxModule', 'bulbApp.authModule',
  'bulbApp.configModule', 'bulbApp.filtersModule'])

  .constant('ACTIVITY', {
  /** How many milliseconds to wait until checking for new activities */
    CHECK_INTERVAL: 60000,
  });
